import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";

import { PdfExportSettings } from "@main/reporting.v3/core/reporting-models";


@Injectable()
export class WidgetHtmlPdfExportingApiService extends BaseDataService {
    readonly url: string = "api/reporting3/widget/html";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public async requestPdfExport(widgetSourceId: string, settings: PdfExportSettings): Promise<string> {
        return this.httpPost(`${widgetSourceId}/pdf-export`, settings);
    }
}